module.exports = __webpack_public_path__ + "img/distributor_active.af4912c9.png";